import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ExternalLink from './ExternalLink';
import Icon, { IconButton } from './Icon';
import Link from './Link';

const Header = styled.div`
  font-weight: var(--bold);
  margin-bottom: 4px;
`;

const Body = styled.div`
  flex-grow: 1;
  line-height: var(--medium-large);
`;

const Wrapper = styled.div`
  align-items: flex-start;
  background-color: var(--primary-x-light);
  border-color: var(--primary-light);
  border-radius: 6px;
  border-style: solid;
  border-width: 2px;
  color: var(--banner-text);
  display: flex;
  justify-content: space-between;
  padding: 12px 16px;

  > ${Icon} {
    color: var(--primary);
    height: var(--medium-large);
    margin-right: 8px;
    width: var(--medium-large);
  }

  > ${IconButton} {
    height: var(--medium-large);
    margin-left: 8px;
    width: var(--medium-large);
  }

  ${ExternalLink}, ${Link} {
    color: inherit;
    font-weight: var(--bold);
    text-decoration: underline;
  }
`;

function BaseNotice({ children, className, header, icon, onDismiss }) {
  return (
    <Wrapper className={className} role="alert">
      {header && <Icon icon={icon || 'info-circle'} role="img" />}

      <Body>
        {header && <Header>{header}</Header>}
        {children}
      </Body>

      {onDismiss && (
        <IconButton icon="times" label="Dismiss notice" onClick={onDismiss} />
      )}
    </Wrapper>
  );
}

BaseNotice.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  header: PropTypes.string,
  icon: PropTypes.string,
  onDismiss: PropTypes.func,
};

const Notice = styled(BaseNotice)``;

export default Notice;

export const NegativeNotice = styled(Notice)`
  background-color: var(--danger-x-light);
  border-color: var(--danger-light);

  > ${Icon} {
    color: var(--danger-dark);
  }
`;

export const WarningNotice = styled(Notice)`
  background-color: var(--warn-light);
  border-color: var(--warn);

  > ${Icon} {
    color: var(--warn-dark);
  }
`;
